import BookPlayer from './BookPlayer'
export default BookPlayer
